export default __webpack_public_path__ + "static/media/iFiction.e7492847.png";